export const NVR_DOWN_ALERT = 'ВидеорегистраторНедоступен'
export const DOOR_DOWN_ALERT = 'ТурникетНедоступен'
export const PANIC_DOWN_ALERT = 'ТревожнаяСтанцияНедоступна'

const active = (alert) => {
  const state = alert?.status
  if (state === 'suppressed' || state === 'resolved') return false
  return true
}

/**
 * startsAt активного down-алерта для устройства.
 * device_id надёжнее instance: instance бывает host:port.
 */
export const pickDeviceDownSince = (alerts, { deviceId, target, alertName } = {}) => {
  const id = deviceId != null && deviceId !== '' ? String(deviceId) : ''
  const targetNorm = target ? String(target).toLowerCase() : ''
  const list = Array.isArray(alerts) ? alerts : []

  const match = list.find((alert) => {
    if (!active(alert)) return false
    const name = alert.labels?.alertname
    if (name && alertName && name !== alertName) return false
    const did = alert.labels?.device_id
    if (id && did != null && String(did) === id) return true
    const instance = String(alert.labels?.instance || '').toLowerCase()
    if (targetNorm && instance && (instance === targetNorm || instance.includes(targetNorm))) {
      return !name || !alertName || name === alertName
    }
    return false
  })

  return match?.startsAt || null
}

export const pickNvrDownSince = (alerts, opts) =>
  pickDeviceDownSince(alerts, { ...opts, alertName: NVR_DOWN_ALERT })

export const pickDoorDownSince = (alerts, opts) =>
  pickDeviceDownSince(alerts, { ...opts, alertName: DOOR_DOWN_ALERT })

export const pickPanicDownSince = (alerts, opts) =>
  pickDeviceDownSince(alerts, { ...opts, alertName: PANIC_DOWN_ALERT })
